import { useQuery } from '@tanstack/react-query'
import { AppShell } from '@/components/layout/app-shell'
import { partnerApi } from '@/lib/api'

export function UsagePage() {
  const usage = useQuery({ queryKey: ['usage'], queryFn: partnerApi.usage, refetchInterval: 30_000 })

  if (usage.isLoading) {
    return <AppShell><p className="text-sm text-fg-muted">Cargando uso...</p></AppShell>
  }
  if (!usage.data) {
    return (
      <AppShell>
        <p className="text-sm text-red-600">
          No se pudo cargar el consumo de tu cuenta. Recarga la página o inténtalo más tarde.
        </p>
      </AppShell>
    )
  }
  const u = usage.data
  return (
    <AppShell>
      <div className="mx-auto max-w-4xl">
        <h1 className="text-3xl font-bold">Uso & Quotas</h1>
        <p className="mt-2 text-sm text-fg-secondary">
          Consumo del mes actual. Refresh automático cada 30s.
        </p>
        <div className="mt-6 space-y-4">
          <Bar label="Documentos este mes" current={u.docs_per_month.current} limit={u.docs_per_month.limit} pct={u.docs_per_month.percent_used} resetAt={u.docs_per_month.reset_at} />
          <Bar label="Webhooks hoy" current={u.webhook_deliveries_per_day.current} limit={u.webhook_deliveries_per_day.limit} pct={u.webhook_deliveries_per_day.percent_used} resetAt={u.webhook_deliveries_per_day.reset_at} />
          <Bar label="Storage (GB)" current={u.storage_bytes.current / 1e9} limit={u.storage_bytes.limit / 1e9} pct={u.storage_bytes.percent_used} unit="GB" />
        </div>
      </div>
    </AppShell>
  )
}

function Bar({ label, current, limit, pct, resetAt, unit }: { label: string; current: number; limit: number; pct: number; resetAt?: string; unit?: string }) {
  const color = pct > 95 ? 'bg-red-500' : pct > 80 ? 'bg-yellow-500' : 'bg-green-500'
  return (
    <div className="rounded-lg border border-border bg-bg-surface p-4">
      <div className="flex justify-between text-sm">
        <span className="font-medium">{label}</span>
        <span className="text-fg-secondary">
          {current.toLocaleString('es-CO', { maximumFractionDigits: 2 })} / {limit.toLocaleString('es-CO', { maximumFractionDigits: 2 })} {unit}
        </span>
      </div>
      <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-bg-elevated">
        <div className={`h-full ${color}`} style={{ width: `${Math.min(100, pct)}%` }} />
      </div>
      <div className="mt-1 flex justify-between text-xs text-fg-muted">
        <span>{pct.toFixed(1)}% usado</span>
        {resetAt && <span>Reset: {new Date(resetAt).toLocaleString('es-CO')}</span>}
      </div>
    </div>
  )
}
